import $ from "jquery"

class GithubAsset {
  blob;
  extension;
  arch = 'x86_64';
  type;
  constructor(blob) {
    this.blob = blob
    this.extension = this.blob.name.split(".").slice(-1)[0]
    this.url = this.blob.browser_download_url

    // check for arch
    if (this.blob.name.includes('arm64') || this.blob.name.includes('aarch64')) {
      this.arch = 'arm64'
    } else if (this.blob.name.includes('armhf')) {
      this.arch = 'armhf'
    } else if (this.blob.name.includes('armv7l')) {
      this.arch = 'armv7l'
    }

    if (this.extension === 'exe' && this.blob.name.includes('portable')) {
      this.type = 'portable'
    } else {
      this.type = 'installer'
    }
  }
}


const apiBase = "https://api.github.com/repos/beekeeper-studio"
const siteBase = "https://github.com/beekeeper-studio"

const GitHub = {


  releaseUrlFor() {
    return [apiBase, 'beekeeper-studio', 'releases/latest'].join("/")
  },

  releasePageFor() {
    return [siteBase, 'beekeeper-studio', 'releases/latest'].join("/")
  },


  getLatestRelease(then, error) {
    $.get(GitHub.releaseUrlFor())
      .done(function( data ) {
        const assets = data.assets.map(function(a) {
          return new GithubAsset(a)
        })
        const result = {
          assets, version: data.tag_name
        }
        then(result)
      })
      .fail(error);
  }
}

export { GitHub, GithubAsset }
